if (document.querySelector('.quantity-wrapper input[name="quantity"]')) {
  document.querySelectorAll('.quantity-wrapper input[name="quantity"]').forEach(function (el) {
    el.addEventListener("change", (e) => {
      let max = e.target.getAttribute('max');
      if (parseInt(e.target.value) > parseInt(max)) {
        e.target.value = max;
      }
    });
  });
}

if (document.querySelector(".payroll-deduction-container .payroll-deduction-open")) {
  document.querySelectorAll(".payroll-deduction-container .payroll-deduction-open").forEach(function (el) {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      let cont = el.closest('.payroll-deduction-container');
      cont.classList.add('active');
    });
  });
}

if (document.querySelector(".payroll-deduction-container .payroll-deduction-close")) {
  document.querySelectorAll(".payroll-deduction-container .payroll-deduction-close").forEach(function (el) {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      let cont = el.closest('.payroll-deduction-container');
      cont.classList.remove('active');
    });
  });
}

document.querySelectorAll('.js-option:not(.swatch)').forEach(function (el) {
  el.addEventListener("click", (e) => {
    document.dispatchEvent(new CustomEvent('theme:variantchanged', {detail: {id: parseInt(document.querySelector('[name="id"]').value)}}))
  })
})

document.addEventListener('theme:cartchanged', (e) => {
  handleCartChanged(e);
})

function handleCartChanged(e) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(response => {
      reloadPayrollDeduction(response);
    });
}

function reloadPayrollDeduction(response) {
  let cont = document.querySelector('.payroll-deduction-container');
  if (!cont || !response) return;
  let warning = cont.querySelector('.warning');
  let content = cont.querySelector('.content');
  let minTotal = parseInt(cont.dataset.minTotal);
  let maxTotal = parseInt(cont.dataset.maxTotal);
  let bands = cont.dataset.bands;
  if (bands) {
    bands = JSON.parse(bands);
  }

  let total = response.original_total_price;

  if (total > maxTotal || total < minTotal) {
    warning.classList.remove('hidden');
    cont.classList.add('hidden');
    content.classList.add('hidden');
  } else {
    warning.classList.add('hidden');
    cont.classList.remove('hidden');
    content.classList.remove('hidden');
  }

  let currentBand = null;
  bands.forEach((band) => {
    let bandTotal = band.maximum_total * 100

    if (!currentBand && bandTotal > total) {
      currentBand = band;
    }
  });

  let monthly = 0;
  let remainder = 0;
  let installments = 0;

  if (currentBand) {
    installments = currentBand.installments_count;
    monthly = Math.floor(total / installments);
    let calcTotal = monthly * installments;

    if (calcTotal < total) {
      remainder = total - calcTotal;
    }
  }

  if (maxTotal < total) {
    currentBand = null
  }
  if (minTotal > total) {
    currentBand = null
  }

  let newEl = document.createElement('div');
  newEl.classList.add('period');

  let newEl2 = document.createElement('div');
  newEl2.classList.add('title');
  newEl.appendChild(newEl2);

  let newEl3 = document.createElement('div');
  newEl3.classList.add('amount');
  newEl.appendChild(newEl3);

  document.querySelector('.payroll-deduction-container .periods').innerHTML = '';

  for (let i = 0; i < installments; i++) {
    let period = i + 1;
    let clone = newEl.cloneNode(true);
    let amount = monthly;

    if (i === (installments - 1)) {
      amount += remainder;
    }

    amount = amount / 100;

    clone.querySelector('.title').innerText = 'Pay Period ' + period;
    clone.querySelector('.amount').innerText = '$' + amount.toFixed(2);

    document.querySelector('.payroll-deduction-container .periods').appendChild(clone);
  }
}

function setCookie(name, value, days = null, minutes = null) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  } else if (minutes) {
    let seconds = minutes * 60;
    expires = "; max-age=" + seconds;
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// Update line item properties with the current store ID, from the cart attributes.
// This is used for the custom carrier at checkout.
const lineItemStoreIdSetter = {

  bound: false,
  running: false,

  log: function () {
    if (window.location.hash == "#enable-lisis-debug") {
      console.log('lineItemStoreIdSetter:', ...arguments)
    }
  },

  init: function () {
    if (this.bound) {
      return;
    }
    this.bound = true;

    let _this = this;
    document.addEventListener("cart:ready", (e) => {
      _this.log('trigger:', "cart:ready")
      _this.run();
    });
    document.addEventListener("cart:updated", (e) => {
      _this.log('trigger:', "cart:updated")
      _this.run();
    });
    // This is nearly always what triggers it, as we get redirected to the cart page after adding a product
    fetch('/cart.js').then(res => res.json()).then(cartData => {
      let storeId = cartData.attributes._store_id ?? null;
      _this.log("storeId on load:", storeId);
      if (storeId) {
        _this.log("calling run:")
        _this.run();
      }
    })

  },

  run: function () {
    this.log("run called", this.running)
    if (!this._running) {
      this.log("starting run")
      this.running = true;
      let _this = this;
      fetch('/cart.js').then(res => res.json()).then(cartData => {
        _this.log("cart.js came back...")
        let storeId = cartData.attributes._store_id ?? null;
        _this.log({storeId});

        if (storeId) {
          let changePromises = cartData.items.filter((item) => {
            return (item.properties._store_id ?? null) != storeId
          }).map((item) => {
            let newProperties = {
              ...item.properties,
              _store_id: storeId
            };
            return () => new Promise((resolve) => {
              _this.log("Property update promise " + item.key)
              fetch('/cart/change.js', {
                'method': 'POST',
                'headers': {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({id: item.key, quantity: item.quantity, properties: newProperties})
              })
                .then(res => res.json())
                .then(data => {
                  resolve(data)
                });
            })
          })

          if (changePromises.length) {
            _this.log("Updating " + changePromises.length + " items...");
            Promise.all(
              changePromises.map(promise => promise().then(() => {
                _this.log('[1 cart item updated]')
              }))
            ).then(() => {
              _this.log("All items updated - done")
              _this.running = false;
            })
          } else {
            _this.log("Nothing to update - done")
            _this.running = false;
          }
        }

      }).catch((e) => {
        _this.log("error (- done)", e)
        _this.running = false;
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', lineItemStoreIdSetter.init());

if (document.querySelector('.collection-filter-btn')) {
  document.querySelector('.collection-filter-btn').addEventListener('click', (e) => {
    toggleCollectionFilters();
  });
}

if (document.querySelector('.collection-filter-cc-popup')) {
  document.querySelector('.collection-filter-cc-popup').addEventListener('click', (e) => {
    toggleCollectionFilters();
  });
}

function toggleCollectionFilters() {
  document.querySelector('body').classList.toggle('filters-open');
  document.querySelector('body').classList.toggle('cc-popup-no-scroll');
  document.querySelector('body').classList.toggle('cc-popup-no-scroll-pad-right');
  document.querySelector('.collection-filter-cc-popup').classList.toggle('cc-popup--visible');
}

// observe the algolia collection page and setup the promo block when loaded
const algoliaPromoBlockObserver = new MutationObserver(mutationList =>
  mutationList.filter(m => m.type === 'childList').forEach(m => {
    setUpAlgoliaPromoBlock();
    m.addedNodes.forEach((e) => {
    });
  }));
if (document.querySelector('.template-collection:not(.algolia-plp-block-added) .main-container')) {
  algoliaPromoBlockObserver.observe(document.querySelector('.template-collection:not(.algolia-plp-block-added) .main-container'), {
    childList: true,
    subtree: true
  });
}

function setUpAlgoliaPromoBlock() {
  if (document.querySelector('.algolia-plp-promo-block') && !document.querySelector('.algolia-plp-promo-block').classList.contains('algolia-plp-block-moved')) {
    let _target = document.querySelector('.algolia-plp-promo-block');
    let target = _target.cloneNode();
    let parent = _target.closest('.ais-Hits-list');
    let newLi = document.createElement('li');

    newLi.classList.add('ais-Hits-item');
    target.classList.add('algolia-plp-block-moved');

    if (!target.querySelector('img')) {
      // Add image
      let newImg = document.createElement('img');
      newImg.setAttribute('src', target.dataset.image);
      target.appendChild(newImg);
    }
    if (!target.querySelector('span')) {
      // Add text
      let newText = document.createElement('span');
      newText.innerText = target.dataset.title;
      target.appendChild(newText);
    }

    newLi.appendChild(target);
    parent.prepend(newLi);

    document.querySelector('body').classList.add('algolia-plp-block-added');

    _target.remove();
  }
}

function replaceQueryParam(param, newval, search) {
  var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
  var query = search.replace(regex, "$1").replace(/&$/, '');

  return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
}

function validateInputCharLimits() {
  if (document.querySelector('input[type="text"][data-character-limit]')) {
    document.querySelectorAll('input[type="text"][data-character-limit]').forEach(el => {
      let val = el.value;
      let length = val.length;
      let charLimit = el.dataset.characterLimit;
      if (charLimit) charLimit = parseInt(charLimit);
    });
  }
}

validateInputCharLimits();

function addItemToCart(item, extras = {}) {

  return new Promise(async (resolve, reject) => {

    const cartResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({...item, ...extras})
    });

    if (cartResponse.ok) {
      resolve({
        status: 200,
        message: 'Item added to cart.',
        cart: await cartResponse.json()
      });
      return;
    }

    reject({
      status: cartResponse.status,
      message: cartResponse.statusText,
      variant_id: item.id,
    });
  });
}

function changeCartItem(data, extras = {}) {

  return new Promise(async (resolve, reject) => {

    const cartResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({...data, ...extras})
    });

    if (cartResponse.ok) {
      resolve({
        status: 200,
        message: `Item updated - ${data.id}.`,
        cart: await cartResponse.json()
      });
      return;
    }

    reject({
      status: cartResponse.status,
      message: cartResponse.statusText,
      data: data,
    });
  });
}

// Open outside links in new tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}